export const environment = {
    production: false,
    host: '',
    api_version: '/v1/api',
    router_version: '/v1/router'
};



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/environments/environment.ts